module.exports = __webpack_public_path__ + "static/media/4playerRoomsPlayed_10000_25000.35a5cba4.png";